import { render, staticRenderFns } from "./ViewStudent.vue?vue&type=template&id=4e3333b5"
import script from "./ViewStudent.vue?vue&type=script&lang=js"
export * from "./ViewStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports